import React from "react";
import { string } from "prop-types";
import HomeIcon from "../../icons/home-icon";
import "./breadcrumb.m.css";
import RightArrow from "../../icons/right-arrow";

const Breadcrumb = ({ name = "" }) => {
  return (
    <div styleName="breadcrumb-wrapper">
      <span styleName="home-icon">
        <HomeIcon />
      </span>
      <span styleName="right-arrow">
        <RightArrow />
      </span>
      <h1 styleName="title">{name}</h1>
    </div>
  );
};

Breadcrumb.propTypes = { name: string };

export default Breadcrumb;
